export default {
    selectAll: 'Select all',
    canSelectAndInvite: 'Now you can select all carriers and invite them to your platform or add them to your list.',
};
